/* global jQuery, KTUtil */

export default class DatePicker {
  static selectorString() {
    return '.DatePicker';
  }

  render(node, props) {
    const arrows = KTUtil.isRTL()
      ? {
          leftArrow: '<i class="la la-angle-right"></i>',
          rightArrow: '<i class="la la-angle-left"></i>',
        }
      : {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        };

    jQuery(node).find('input[type="text"]').datepicker({
      orientation: 'bottom left',
      templates: arrows,
      format: 'dd.mm.yyyy',
      startDate: '+0d',
      todayHighlight: true,
      language: 'de',
      weekStart: 1,
    });
  }
}

jQuery.fn.datepicker.dates.de = {
  days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  daysShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
  daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  months: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],
  monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  today: 'Heute',
  monthsTitle: 'Monate',
  clear: 'Löschen',
  weekStart: 1,
  format: 'dd.mm.yyyy',
};
